import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Select } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    packagesCreatePackageRequest,
    packagesGetPackageRequest,
    packagesUpdatePackageRequest,
    searchDealersRequest,
    clearRedux,
} from 'Redux/actions';

//Styles
import './index.scss';

const createEditPackage = (props) => {
    const { tableRef, getPackage, paramDealer } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    const [name, setName] = useState("");
    const [projectId, setProjectId] = useState(paramDealer ? { id: "PX", label: "PX" } : null);
    const [description, setDescription] = useState("");
    const [edit, setEdit] = useState(false);
    const [roleId, setRoleId] = useState(null);
    const [dealer, setDealer] = useState(paramDealer || null);

    const { loading, openModal, create, update, role, roleinfo } = useSelector(state => state.createEditPackageRedux);
    const { dealers, dealersLoading } = useSelector(state => state.generalRedux);
    const handleSave = () => {
        let payload = {
            name,
            description,
        }
        if (!edit) {
            payload.projectId = projectId?.id
            if (projectId.id === "PX") {
                payload.dealerId = dealer?.id
            }
            dispatch(packagesCreatePackageRequest(payload));
        }
        else {
            payload.id = roleId;
            dispatch(packagesUpdatePackageRequest(payload));
        }
    }

    const closeModal = () => {
        setName("");
        dispatch(clearRedux("CREATE_EDIT_PACKAGE"));
        setEdit(true);
        setDescription("");
        setRoleId(null);
        setDealer(null);
    }

    useEffect(() => {
        if (roleinfo) {
            setName(roleinfo.name || '')
            setDescription(roleinfo?.description || '')
            dispatch(clearRedux("CREATE_EDIT_PACKAGE", { roleinfo: null }))
        }
        if (create?.id) {
            NotificationManager.success(
                messages['create_edit_package_success_create'],
                messages['create_edit_package_create_title'],
                3000,
            );
            tableRef && tableRef.current.getData();
            closeModal();
            dispatch(clearRedux("CREATE_EDIT_PACKAGE", { create: null }))
        }
        if (update?.id) {
            NotificationManager.success(
                messages['create_edit_package_success_edit'],
                messages['create_edit_package_edit_title'],
                3000,
            );
            tableRef && tableRef.current.getData();
            getPackage && getPackage();
            closeModal();
            dispatch(clearRedux("CREATE_EDIT_PACKAGE", { update: null }))
        }
    }, [create, update, roleinfo])

    useEffect(() => {
        if (role) {
            dispatch(packagesGetPackageRequest(role));
            setRoleId(role);
            dispatch(clearRedux("CREATE_EDIT_PACKAGE", { role: null }))
            setEdit(true);
        }
    }, [role]);

    useEffect(() => {
        if (openModal) {
            dealers && dealers.length === 0 && dispatch(searchDealersRequest());
        }
    }, [openModal]);

    return (
        <Modal
            open={openModal}
            title={!edit ? messages['create_edit_package_create_title'] : messages['create_edit_package_edit_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => handleSave()}
                    >
                        <Input
                            label={messages['create_edit_package_name']}
                            placeholder={messages['create_edit_package_name']}
                            value={name}
                            onChange={(value) => setName(value)}
                            required
                            requiredMessage={messages['required_field']}
                            maxLength={40}
                        />
                        {
                            !edit &&
                            <div className="package-description">
                                <Select
                                    id="select-project-ids"
                                    label={messages['create_edit_package_label']}
                                    placeholder={messages['create_edit_package_label']}
                                    options={[
                                        {
                                            id: "PM",
                                            label: "PM"
                                        },
                                        {
                                            id: "PX",
                                            label: "PX"
                                        }
                                    ]}
                                    textField="label"
                                    valueField="id"
                                    value={projectId}
                                    onChange={(value) => setProjectId(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    disabled={paramDealer}
                                />
                            </div>
                        }
                        {
                            projectId?.id === "PX" &&
                            <div className="package-description">
                                <Select
                                    id="select-brands"
                                    label={messages['create_edit_package_brand']}
                                    placeholder={messages['create_edit_package_brand']}
                                    options={dealers || []}
                                    valueField="id"
                                    textField="name"
                                    value={dealer}
                                    onChange={(value) => setDealer(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    disabled={dealersLoading || paramDealer}
                                />
                            </div>
                        }
                        <div className="package-description" >
                            <Input
                                type="textarea"
                                label={messages['create_edit_package_description']}
                                placeholder={messages['create_edit_package_description']}
                                value={description}
                                onChange={(value) => setDescription(value)}
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={(e) => {
                        e.preventDefault();
                        closeModal();
                    }}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    onClick={(e) => {
                        e.preventDefault();
                        formRef.current?.submit();
                    }}
                    className="btn-dark-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default createEditPackage;